import Link from 'next/link';

import { Brand } from '@/components/Brand';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { BtnDark } from '../Buttons';
import { debounce } from 'lodash';

export const Navigation = () => {
  const { asPath } = useRouter();
  const [loading, setLoading] = useState<boolean>(true);
  const [mobileActive, setMobileActive] = useState<boolean>(false);
  const [background, setBackground] = useState<boolean>(false);

  useEffect(() => {
    setLoading(false);

    window.addEventListener(
      'scroll',
      debounce(handleScroll, 200, { leading: true }),
    );

    return () => {
      window.removeEventListener(
        'scroll',
        debounce(handleScroll, 200, { leading: true }),
      );
    };
  }, []);

  const handleScroll = () => {
    const pos = window.pageYOffset || document.documentElement.scrollTop;

    if (50 < pos) {
      setBackground(true);
    } else {
      setBackground(false);
    }
  };

  return (
    <nav
      className={`navigation flex between middle${loading ? ' out' : ' in'}${
        mobileActive ? ' active' : ''
      }${background ? ' background' : ''}`}
    >
      <div className="container flex middle center lexend-body-md">
        {/* DESKTOP PART */}
        <ul className="flex left end ul-desktop">
          <li className="middle flex">
            <Link
              href="/about-us"
              className={asPath === '/about-us' ? 'active' : ''}
            >
              About Us
            </Link>
          </li>
          <li className="middle flex">
            <Link
              href="/infrastructure"
              className={asPath === '/infrastructure' ? 'active' : ''}
            >
              Infrastructure
            </Link>
          </li>
        </ul>
        <div className="brand">
          <Brand />
        </div>
        <ul className="flex right start ul-desktop">
          <li className="middle flex">
            <Link href="/xbg" className={asPath === '/xbg' ? 'active' : ''}>
              XBG Token
            </Link>
          </li>
        </ul>

        {/* MOBILE PART */}
        <BtnDark label="Explore Apps" href="" className="explore-apps" />

        <button className="menu" onClick={() => setMobileActive(!mobileActive)}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </button>

        <ul className="flex left end ul-mobile">
          <li className="middle flex">
            <Link
              href="/about-us"
              className={asPath === '/about-us' ? 'active' : ''}
            >
              About Us
            </Link>
          </li>
          <li className="middle flex">
            <Link
              href="/infrastructure"
              className={asPath === '/infrastructure' ? 'active' : ''}
            >
              Infrastructure
            </Link>
          </li>
          <li className="middle flex">
            <Link href="/xbg" className={asPath === '/xbg' ? 'active' : ''}>
              XBG Token
            </Link>
          </li>
          <li className="middle flex">
            <Link
              href="/presale"
              className={asPath === '/presale' ? 'active' : ''}
            >
              XBG Presale
            </Link>
          </li>
        </ul>
      </div>

      {/*
      <div className="explore-apps flex">
        <Link href="/#landing-next-gen">
          <a className="explore-apps flex">
            <BtnDark label="Explore Apps" href="" />
          </a>
        </Link>

        <BtnDark
          label="Explore Apps"
          href=""
          onClick={(e: any) => {
            e.preventDefault();
            const hero = document.getElementsByClassName('landing-next-gen')[0];
            const rect = hero.getBoundingClientRect();
            scrollTo(window.scrollY, window.scrollY + rect.y, 0);
          }}
        />
      </div>
        */}
    </nav>
  );
  // OG Navigation
  // return (
  //   <nav
  //     className={`navigation flex between middle${loading ? ' out' : ' in'}`}
  //   >
  //     <div className="container flex middle center lexend-body-md">
  //       <ul className="flex left end">
  //         <li className="middle flex">
  //           <Link href="">Ecosystem</Link>
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="25"
  //             viewBox="0 0 24 25"
  //             fill="none"
  //           >
  //             <path
  //               d="M12 15.8746L6 9.87461L7.4 8.47461L12 13.0746L16.6 8.47461L18 9.87461L12 15.8746Z"
  //               fill="#F0F0F0"
  //             />
  //           </svg>
  //         </li>
  //         <li className="middle flex">
  //           <Link href="">Product</Link>
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="25"
  //             viewBox="0 0 24 25"
  //             fill="none"
  //           >
  //             <path
  //               d="M12 15.8746L6 9.87461L7.4 8.47461L12 13.0746L16.6 8.47461L18 9.87461L12 15.8746Z"
  //               fill="#F0F0F0"
  //             />
  //           </svg>
  //         </li>
  //       </ul>
  //       <div className="brand">
  //         <Brand />
  //       </div>
  //       <ul className="flex right start">
  //         <li className="middle flex">
  //           <Link href="">Community</Link>
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="25"
  //             viewBox="0 0 24 25"
  //             fill="none"
  //           >
  //             <path
  //               d="M12 15.8746L6 9.87461L7.4 8.47461L12 13.0746L16.6 8.47461L18 9.87461L12 15.8746Z"
  //               fill="#F0F0F0"
  //             />
  //           </svg>
  //         </li>
  //         <li className="middle flex">
  //           <Link href="">Company</Link>
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             width="24"
  //             height="25"
  //             viewBox="0 0 24 25"
  //             fill="none"
  //           >
  //             <path
  //               d="M12 15.8746L6 9.87461L7.4 8.47461L12 13.0746L16.6 8.47461L18 9.87461L12 15.8746Z"
  //               fill="#F0F0F0"
  //             />
  //           </svg>
  //         </li>
  //       </ul>
  //     </div>

  //     <div className="explore-apps flex">
  //       <BtnDark
  //         label="Explore Apps"
  //         href=""
  //         onClick={(e: any) => {
  //           e.preventDefault();
  //           const hero = document.getElementsByClassName('landing-next-gen')[0];
  //           const rect = hero.getBoundingClientRect();
  //           scrollTo(window.scrollY, window.scrollY + rect.y, 0);
  //         }}
  //       />
  //     </div>
  //   </nav>
  // );
};
